<template>
  <div class="accounts">
    <div class="modal-accounts">
      <div class="accounts-card text-center">
        <div class="accounts-title">
          Você está na conta: <strong>{{ getAccount.name }}</strong>
          <hr>
          <p>Estas são as contas das quais você faz parte:</p>
        </div>
        <div class="accounts-content">

          <div class="row mt-4">
            <div class="col-md-12">
              <input v-model="searchValue" class="input form-control"
                     @keypress.enter="find()"
                     :placeholder="isSuperUser ? 'Pesquisar por Nome ou ID da conta' : 'Pesquisar por nome da conta'">
              <search-icon @click="find()" class="icon icon-within"/>
            </div>
          </div>

          <table>
            <thead>
            <tr>
              <th v-if="isSuperUser">ID</th>
              <th>Nome</th>
              <th>Criado em</th>
              <th>Criado por</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="account in accounts" :key="account.id">
              <td v-if="isSuperUser">{{ account.id }}</td>
              <td>{{ account.name }}</td>
              <td>{{ account.createdAt | datetime }}</td>
              <td></td>
              <td>
                <button v-if="account.id !== getAccount.id" @click="changeAccount(account)" class="btn btn-outline">Trocar de conta</button>
              </td>
            </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-md-12 my-1">
              <Pagination
                v-model="meta.currentPage"
                :total-count="meta.totalCount"
                :total-pages="meta.totalPages"
                @pagination="pagination"
              />
            </div>
          </div>

        </div>
        <hr>
        <div class="go-back">
          <button @click="$router.back()" type="button" class="btn btn-primary btn-xl" data-dismiss="modal">Voltar</button>
        </div>

        <template v-if="isSuperUser">
          <hr>
          <div class="go-back">
            <button @click="sendToWizard()" class="btn btn-outline btn-xl">
              Criar nova Conta
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>

</template>

<script>
  import GetAccount from '@/mixins/GetAccount'
  import { notifySessionChanged } from '@/utils/sessionChannel'
  import GetUser from '@/mixins/GetUser'
  import ModelMapper from '@/mixins/ModelMapper'
  import Pagination from '@/components/shares/specialTag/Pagination'
  import { SearchIcon } from 'vue-feather-icons'

  export default {
    components: { Pagination, SearchIcon },
    computed: {
      accounts() {
        return this.getModels || []
      }
    },
    created() {
      this.order.name = 'asc'
      this.asyncTemplateSelect()
    },
    data() {
      return {
        nameModel: 'Account',
        searchValue: ''
      }
    },
    methods: {
      changeAccount(account) {
        this.openGlobalLoad()
        this.$ls.clear()
        this.axios.post(`accounts/${account.id}/set_current`)
          .then(() => {
            notifySessionChanged()
            location.href = '/'
          })
          .catch(e => this.$notify.addError(e))
          .finally(() => this.closeGlobalLoad())
      },
      find() {
        this.query.generic = ''
        this.query.id = ''

        if (this.searchValue) {
          if (/^\d+$/.test(this.searchValue.trim())) {
            this.query.id = this.searchValue.trim()
          } else {
            this.query.generic = this.searchValue.trim()
          }
        }

        this.asyncTemplateSelect()
      },
      sendToWizard() {
        this.setAccount(null)
        this.$router.push('/wizard')
      }
    },
    mixins: [GetAccount, ModelMapper, GetUser],
    name: 'Account',
  }
</script>

<style scoped>

  .accounts {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color:rgba(0,0,0,0.4);
  }

  .modal-accounts {
    position: absolute;
    width: 100%;
    height: 100%;
    color: var(--primary-text-color);
    background: var(--background-color);
    overflow-y: auto;
    display: flex;
    justify-content: center;
  }
  .accounts-card {
    margin: 64px 0;
    height: fit-content;
    border-radius: 8px;
    transition: .2s;
    padding: 2em;
    background: var(--card-bg);
    color: var(--card-text-color);
    box-shadow: 0px 4px 50px var(--shadow-color);
  }

  @media screen and (max-width: 600px) {

    .accounts-card {
      width: 100%;
      /*height: 90%;*/
      padding-left: 5px;
      padding-right: 5px;
    }

    .modal-accounts{
      overflow-y: auto;
      display: flex;
      justify-content: center;
    }

  }

</style>
